import * as React from 'react';

function SvgClose(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={13.909} height={13.909} {...props}>
      <path
        d="M8.608 6.955l4.959-4.959A1.169 1.169 0 0011.914.343L6.955 5.302 1.998.342A1.169 1.169 0 00.345 1.995l4.959 4.959-4.959 4.959a1.169 1.169 0 001.653 1.653l4.959-4.959 4.959 4.959a1.169 1.169 0 001.653-1.653z"
        data-name="Path 348"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgClose;
